import { Box } from "@mui/material";

interface Props {
  url: string;
  width?: number | string;
  height?: number | string;
}

const LoomEmbeded = ({ url, width = "100%", height = "100%" }: Props) => {
  return (
    <Box component="div">
      <Box
        component="iframe"
        allowFullScreen={true}
        src={url}
        sx={{ border: 0, width, height }}
      />
    </Box>
  );
};

export default LoomEmbeded;
